if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends HTMLElement {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.dataset.cartQuantity) === 0) {
            this.addToCart(event);
          } else {
            this.updateCart(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'quick-add') {
            return;
          }
          // If its another section that made the update
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      getInput() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        const input = this.getInput();
        if (!input) {
          console.error('No input found for active input listener.');
          return;
        }
        input.addEventListener('focusin', (event) => event.target.select());
        this.isEnterPressed = false;
      }      

      listenForKeydown() {
        this.getInput().addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.getInput().blur();
            this.isEnterPressed = true;
          }
        });
      }

      resetQuantityInput(id) {
        const input = document.getElementById(id);
        input.value = input.getAttribute('value');
        this.isEnterPressed = false;
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      updateCart(event) {
        console.log('🛠️ Debug: Starting updateCart...');
        this.lastActiveInputId = event.target.getAttribute('data-index');
        this.quantity.classList.add('quantity__input-disabled');
        this.selectProgressBar().classList.remove('hidden');
    
        const body = JSON.stringify({
            quantity: event.target.value,
            id: event.target.getAttribute('data-index'),
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: this.getSectionsUrl(),
        });
    
        console.log('🛠️ Debug: Request Payload for Update:', body);
    
        fetch(`${routes.cart_change_url}`, { ...fetchConfig('javascript'), ...{ body } })
            .then((response) => response.text())
            .then((state) => {
                const parsedState = JSON.parse(state);
                console.log('🛠️ Debug: Parsed cart state:', parsedState);
                this.quantity.classList.remove('quantity__input-disabled');
    
                if (parsedState.description || parsedState.errors) {
                    console.error('❌ Error updating cart:', parsedState);
                    event.target.setCustomValidity(parsedState.description);
                    event.target.reportValidity();
                    this.resetQuantityInput(event.target.id);
                    event.target.select();
                    this.cleanErrorMessageOnType(event);
                    throw new Error('Error updating cart: ' + parsedState.description || parsedState.errors);
                }
    
                this.renderSections(parsedState);
    
                // Check if the current item is in the cart
                const variantId = parseInt(event.target.getAttribute('data-index'), 10);
                console.log('🔍 Debug: Checking for variant ID in cart:', variantId);
    
                const cartItem = parsedState.items.find((item) => item.id === variantId);
                console.log('🔍 Debug: Cart item for variant ID:', cartItem);
    
                const quickAddBulkElements = document.querySelectorAll(`quick-add-bulk[data-id="${variantId}"]`);
                console.log(`🔍 Debug: Found ${quickAddBulkElements.length} quick-add-bulk elements for variant ID ${variantId}`);
    
                if (cartItem && cartItem.quantity > 0) {
                    console.log(`✅ Adding "has-item" class for variant ID: ${variantId}`);
                    quickAddBulkElements.forEach((element) => element.classList.add('has-item'));
                } else {
                    console.log(`❌ Removing "has-item" class for variant ID: ${variantId}`);
                    quickAddBulkElements.forEach((element) => element.classList.remove('has-item'));
                }
    
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
            })
            .catch((error) => {
                console.error('❌ updateCart error:', error);
            })
            .finally(() => {
                this.selectProgressBar().classList.add('hidden');
                console.log('🛠️ Debug: Progress bar hidden for updateCart');
            });
    }
    

      addToCart(event) {
  console.log('Starting addToCart...');
  this.quantity.classList.add('quantity__input-disabled');
  this.selectProgressBar().classList.remove('hidden');
  this.lastActiveInputId = event.target.getAttribute('data-index');

  const inputQuantity = parseInt(event.target.value, 10); // User's desired quantity
  const currentCartQuantity = parseInt(this.getInput().getAttribute('value'), 10) || 0; // Current cart quantity
  const deltaQuantity = inputQuantity - currentCartQuantity; // Difference to adjust

  console.log('Input Quantity:', inputQuantity);
  console.log('Current Cart Quantity:', currentCartQuantity);
  console.log('Delta Quantity (to update):', deltaQuantity);

  if (deltaQuantity === 0) {
    console.log('No change in quantity, skipping addToCart.');
    this.quantity.classList.remove('quantity__input-disabled');
    this.selectProgressBar().classList.add('hidden');
    return;
  }

  const isSubtraction = deltaQuantity < 0;
  const url = isSubtraction ? routes.cart_change_url : routes.cart_add_url;

  let body;
  if (isSubtraction) {
    body = JSON.stringify({
      quantity: inputQuantity,
      id: this.dataset.id,
      sections: this.getSectionsToRender().map((section) => section.section),
    });
  } else {
    body = JSON.stringify({
      items: [
        {
          id: parseInt(this.dataset.id, 10),
          quantity: Math.abs(deltaQuantity),
        },
      ],
      sections: this.getSectionsToRender().map((section) => section.section),
    });
  }

  console.log('Request URL:', url);
  console.log('Final Payload:', body);

  fetch(url, { ...fetchConfig('javascript'), ...{ body } })
    .then((response) => {
      if (!response.ok) {
        console.error(`Server responded with status ${response.status}`);
        return response.text().then((errText) => {
          console.error('Server response:', errText);
          throw new Error(`Fetch failed: ${response.statusText}`);
        });
      }
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      this.quantity.classList.remove('quantity__input-disabled');

      if (parsedState.description || parsedState.errors) {
        console.error('Error in Parsed State:', parsedState);
        event.target.setCustomValidity(parsedState.description);
        event.target.reportValidity();
        this.resetQuantityInput(event.target.id);
        event.target.select();
        this.cleanErrorMessageOnType(event);
        throw new Error('Error updating cart: ' + (parsedState.description || parsedState.errors));
      }

      console.log('Parsed State:', parsedState);

      const variantId = parseInt(this.dataset.id, 10);
      const cartItem = parsedState.items.find((item) => item.id === variantId);

      if (cartItem) {
        console.log(`Keeping "has-item" class for variant ID: ${variantId}`);
        this.classList.add('has-item');
        this.getInput().value = cartItem.quantity;
        this.getInput().setAttribute('value', cartItem.quantity);
      } else {
        console.log(`Removing "has-item" class for variant ID: ${variantId}`);
        this.classList.remove('has-item');
        this.getInput().value = 0;
        this.getInput().setAttribute('value', 0);
      }

      this.renderSections(parsedState);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
    })
    .catch((error) => {
      console.error('addToCart error:', error);
    })
    .finally(() => {
      this.selectProgressBar().classList.add('hidden');
      console.log('Progress bar hidden for addToCart');
    });
}

      getSectionsToRender() {
        const closestCollection = this.closest('.collection-quick-add-bulk');
        console.log('Closest Collection:', closestCollection);
        if (!closestCollection) {
          throw new Error('Closest `.collection-quick-add-bulk` not found.');
        }
        console.log('Dataset ID of closest collection:', closestCollection.dataset.id);
      
        return [
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '#CartDrawer',
            section: 'cart-drawer',
          },
          {
            id: `quick-add-bulk-${this.dataset.id}-${closestCollection.dataset.id}`,
            section: closestCollection.dataset.id,
            selector: `#quick-add-bulk-${this.dataset.id}-${closestCollection.dataset.id}`,
          }
        ];
      }

      getSectionsUrl() {
        if (window.pageNumber) {
          return `${window.location.pathname}?page=${window.pageNumber}`;
        } else {
          return `${window.location.pathname}`;
        }
      }

      getSectionInnerHTML(html, selector) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      let element = parsedHTML.querySelector(selector);

      if (!element) {
        console.warn(`Element with selector "${selector}" not found in parsed HTML. Attempting fallback.`);

        // Search the entire live DOM as a fallback
        const liveElement = document.querySelector(selector);
        if (liveElement) {
          console.log('Fallback succeeded. Found live element in the DOM:', liveElement);
          return liveElement.innerHTML;
        }

        console.error(`No element found with selector "${selector}" in either parsed HTML or live DOM.`);
        console.error('Parsed HTML Content:', html);
        return ''; // Gracefully handle missing element
      }

      return element.innerHTML;
    }

    renderSections(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = document.getElementById(section.id);
        if (!sectionElement) {
          console.error(`Section element with ID "${section.id}" not found.`);
          return;
        }
    
        if (
          sectionElement.parentElement &&
          sectionElement.parentElement.classList.contains('drawer')
        ) {
          parsedState.items.length > 0
            ? sectionElement.parentElement.classList.remove('is-empty')
            : sectionElement.parentElement.classList.add('is-empty');
    
          setTimeout(() => {
            const cartOverlay = document.querySelector('#CartDrawer-Overlay');
            const cart = document.querySelector('#bigcart');
            if (cartOverlay && cart && cart.close) {
              cartOverlay.addEventListener('click', cart.close.bind(cart));
            } else {
              console.error('Cart or CartDrawer-Overlay is not available.');
              console.log('Cart:', cart);
              console.log('CartDrawer-Overlay:', cartOverlay);
            }
          });
        }
    
        const elementToReplace =
          sectionElement.querySelector(section.selector) || sectionElement;
        if (!elementToReplace) {
          console.error(
            `Element to replace with selector "${section.selector}" not found.`
          );
          return;
        }
    
        const sectionContent = parsedState.sections[section.section];
        if (!sectionContent) {
          console.error(`Section content for "${section.section}" not found in parsed state.`);
          return;
        }
    
        // Replace section content
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          sectionContent,
          section.selector
        );
    
        // ✅ Manually reapply event listeners for `.carticonwrapper`
        this.reapplyCartIconListeners();
      });
    
      if (this.isEnterPressed) {
        const quantityInput = this.querySelector(`#Quantity-${this.lastActiveInputId}`);
        if (quantityInput) {
          quantityInput.select();
        } else {
          console.error(`Quantity input with ID "Quantity-${this.lastActiveInputId}" not found.`);
        }
      }
    
      this.listenForActiveInput();
      this.listenForKeydown();
    }
    
    /**
     * Manually reapply event listeners to cart icon after re-rendering
     */
    reapplyCartIconListeners() {
      document.querySelectorAll('.carticonwrapper').forEach((cartIcon) => {
        cartIcon.removeEventListener('click', this.openCartDrawer); // Prevent duplicate listeners
        cartIcon.addEventListener('click', this.openCartDrawer);
      });
    }
    
    /**
     * Open cart drawer when cart icon is clicked
     */
    openCartDrawer(event) {
      event.preventDefault();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.open(event.target);
      } else {
        console.error('Cart Drawer not found.');
      }
    }
    }
  );
}